// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    POST_VIDEO_LOADING() {
      return {
        isLoading: true,
        postVideo: action.postVideo
      };
    },
    POST_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.postVideo
      };
    },
    POST_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
